export const DATA_ID_X_CARTPAGE_PRODS_SHIPSELECT = 'X_CartPage_Prods_ShipSelect'
